import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Navigate } from 'react-router-dom';
import { StoreModel } from 'models/StoreModel';
import { LoginUser } from 'models/LoginUser';
import Translator from 'app/components/common/Translator';
import { PageContentHeader } from 'app/components/common/PageContentHeader';

interface Props {
    loginUser: LoginUser;
}

class Nothing extends React.Component<Props> {
    loggedIn() {
        return this.props.loginUser && this.props.loginUser.token;
    }

    render() {
        return (
            !this.loggedIn() ? <Navigate replace to='/account/login' /> :
                <div className="c-page__content">
                    <PageContentHeader text="Nothing to see here..." />
                    <div className="c-dashboard">
                        <div className="c-card">
                           <Translator text="You shouldn't be here, how did you get here anyway??"/>
                        </div>
                    </div>
                </div>
        );
    }
}

function mapStateToProps(state: StoreModel) {
    return {
        loginUser: state.loginUser,
    };
}
function mapDispatchToProps(_dispatch: Dispatch) {
    return {
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Nothing);